export interface SwatchAppState {
  auth: any;
  selectedEc: DefaultItemType | null;
  ecList: DefaultItemType[];
  loggedInUser: User;
  searchedProductSelected: Finish | null;
  productSearchResultsTable: {
    data: any;
    pageConfig: any;
  };
  inventoryProductSearchResult: {
    data: any;
    pageConfig: any;
  };
  inventorySkuDetails: {
    data: any;
    pageConfig: any;
  };
  inventorySampleDetails: {
    data: any;
    pageConfig: any;
  };
  lendingHistoryDetails: {
    data: any;
    pageConfig: any;
  };
  breadcrumb: Breadcrumb;
  analyticsInstance: Record<string, any> | null;
  config: any;
}

export interface DefaultItemType {
  name: number;
  display_name: string;
}

export interface Breadcrumb {
  items: BreadcrumbItem[];
  routeActive: string;
}

export interface BreadcrumbItem {
  name: string;
  display_name: string;
  href: string;
  routerLink: string;
}

export interface ProductSearch {
  sku_code: string;
  sku_name: {
    name: string;
    brand: string | null;
    img_url: string | null;
  };
  action: null;
  finishes: FinishListItem[];
}

export interface Finish extends ProductSearch {
  samples: SampleItem[] | null;
}

export interface SampleItem {
  sample_id: string;
  condition: string;
  location: string;
}

export interface FinishListItem {
  displayName: string;
  name: string;
  selected: boolean;
  meta: number;
  subtext: string;
  imageurl: string | null;
}

export interface Product {
  name: string;
  brand: string;
  product_code: string | number;
  img_url: string | null;
  availability: object;
  skus: Sku[] | null;
}

export interface Sku {
  sku_name: string;
  sku_code: string | number;
  availability: object;
  samples: Sample[] | null;
}

export interface Sample {
  sample_id: string | number;
  conditiong: string;
  location: string;
  remark: string;
  availability: string;
}

export interface UiAppState {
  isOnMobileDevice: boolean;
  modalElement: { [key: string]: string | boolean };
  toastsList: Toast[];
}

export interface Toast {
  severity: string;
  icon: string;
  title: string;
  message: string;
  duration: number;
  key: string;
}

export interface User {
  id: number | string | null;
  name: string | null;
  display_name?: string | null;
  email: string | null;
  phone: string | null;
  image_url: string | null;
  city?: DefaultItemType | null;
  hasWriteAccess?: boolean;
}

export const validEvents = {
  LOGIN_CLICKED: "Login-Clicked",
  LOGIN_SUCCESS: "Login-Success",
  LOGIN_FAILED: "Login-Failed",
  CMS_SEARCH: "CMS Product Search",
  GET_CMS_PRODUCT_SKU: "CMS SKU get details",
  EC_CHANGED: "User switched EC",
  ADD_SAMPLES: "Samples added to inventory",
  SEARCH_INVENTORY_PRODUCTS: "Inventory Product Search",
  SEARCH_INVENTORY_SKUS: "Inventory SKUs Search",
  SEARCH_INVENTORY_SAMPLES: "Inventory Samples Search",
  SKU_OOS_REQUEST: "Request for OOS Sample",
  SAMPLE_ISSUE: "Issue inventory sample",
  SAMPLE_RETURN: "Return inventory issued sample",
  SEARCH_LENDINGS: "Search lending transactions",
  LOGOUT: "User logged out",
  DOWNLOAD_SINGLE_LABEL: "Download single label",
  VIEW_ALL_ITEM_DETAILS: "View all item details"
};

export type segmentEvents =
  | "LOGIN_CLICKED"
  | "LOGIN_SUCCESS"
  | "LOGIN_FAILED"
  | "EC_CHANGED"
  | "CMS_SEARCH"
  | "GET_CMS_PRODUCT_SKU"
  | "ADD_SAMPLES"
  | "SEARCH_INVENTORY_PRODUCTS"
  | "SEARCH_INVENTORY_SKUS"
  | "SEARCH_INVENTORY_SAMPLES"
  | "SKU_OOS_REQUEST"
  | "SAMPLE_ISSUE"
  | "SAMPLE_RETURN"
  | "SEARCH_LENDINGS"
  | "LOGOUT"
  | "DOWNLOAD_SINGLE_LABEL"
  | "VIEW_ALL_ITEM_DETAILS";

export const SwatchSearchOptions = [
  { name: "sku_display_name__icontains", display_name: "Display Name" },
  { name: "brand__icontains", display_name: "Brand" },
  { name: "product_code__icontains", display_name: "Product Code" },
  { name: "sku_code__icontains", display_name: "SKU Code" },
  { name: "unique_code__icontains", display_name: "Sample ID" }
];

export const TransactionSearchOptions = [
  { name: "unique_code__icontains", display_name: "Sample ID" },
  { name: "issued_to__in", display_name: "User" }
  // { name: "unique_code", display_name: "Sample ID" },
  // { name: "product_code", display_name: "Product Code" },
  // { name: "sku_code", display_name: "SKU Code" },
];

export const SwatchCMSSearchOptions = [
  { name: "display_name", display_name: "Display Name" },
  { name: "brand", display_name: "Brand" },
  { name: "product_code", display_name: "Product Code" }
];

export const ProductTabFilterOptions = [
  { name: "", display_name: "All", key: "1" },
  { name: "AVAILABLE", display_name: "Available", key: "2" },
  { name: "ISSUED", display_name: "Issued", key: "3" }
  // { name: "OUT_OF_STOCK", display_name: "Out of Stock", key: "4" }
];

export const ItemConditionOptions = [
  { name: "GOOD", display_name: "Good" },
  { name: "DAMAGED", display_name: "Damaged" },
  { name: "MISSING", display_name: "Missing" },
  { name: "OUT_OF_SERVICE", display_name: "Out of Service" },
  { name: "DISCONTINUED", display_name: "Discontinued" }
];

export const ItemIssueConditionOptions = [
  { name: "GOOD", display_name: "Good" },
  { name: "DAMAGED", display_name: "Damaged" }
];

export const DateFilterItems = [
  { name: "show_all", displayName: "Show All Dates" },
  { name: "issue_date", displayName: "Issued Between" },
  { name: "return_date", displayName: "Returned Between" },
  { name: "expected_return_date", displayName: "Expected Return" }
];

export const PageConfig = {
  limit: 10,
  offset: 0,
  page: 1,
  pagecount: 1,
  sortBy: {},
  query: "",
  totalcount: 0
};

export const DefaultItem = {
  name: "",
  display_name: ""
};

export const ToastNotificationDefaultTimeout = 4000;
export const PRODUCT_CATEGORY_ID = 135;

export const RenderConfs = {
  marginTop: "2mm",
  marginBottom: "2mm",
  marginLeft: "3mm",
  marginRight: "3mm"
};

export const SampleOptionItems = [
    { name: "download", display_name: "Download Label", icon: "Download" },
    { name: "details",  display_name: "View All Details", icon: "Info" }
];
